import { DASH } from '../lib/fmt';
import { MONTH_KEYS, SCHEDULE_SLOTS } from './constants';
import type { Dest, GroupKey, LoadBandKey, Permission, SegmentKey, StageId } from './types';

export const GROUP_LABEL: Readonly<Record<GroupKey, string>> = {
  sen: '線路G',
  mu: '無線G',
  ki: '機器G',
  dc: 'DC・PJT',
  mg: '管理・支援',
};

export const DEST_LABEL: Readonly<Record<Dest, string>> = {
  G: '現場',
  A: 'Kセンター（FL）',
  B: 'BO・集中化',
  C: '協力会社・外部',
};

export const DEST_LONG_LABEL: Readonly<Record<Dest, string>> = {
  G: '現場に残す',
  A: 'Kセンター（フロントローディング）',
  B: 'バックオフィス・集中化',
  C: '協力会社・外部へ',
};

export const SEGMENT_LABEL: Readonly<Record<SegmentKey, string>> = {
  base: '基盤工事',
  ext: '基盤拡大',
  grow: '成長分野',
};

export const STAGE_LABEL: Readonly<Record<StageId, string>> = {
  1: '実態調査',
  2: '具体的内容検討',
  3: '簡易仕様書作成',
  4: '実施内容説明',
  5: '運用開始',
};

export const LOAD_BAND_LABEL: Readonly<Record<LoadBandKey, string>> = {
  free: '空き（0%）',
  light: '余力大（〜50%）',
  fit: '適正（60〜100%）',
  over: '超過（110〜120%）',
  heavy: '過負荷（130%〜）',
};

export const monthLabel = (index: number): string => {
  const key = MONTH_KEYS[index];
  return key === undefined ? DASH : `${Number(key.slice(5))}月`;
};

/** その月(0..11)の西暦年。範囲外は null。年をまたぐ月の表示(2027/1月 など)をデータから導くために使う。 */
export const monthYear = (index: number): number | null => {
  const year = Number(MONTH_KEYS[index]?.slice(0, 4));
  return Number.isInteger(year) ? year : null;
};

const JUN = ['上', '中', '下'] as const;

export const junLabel = (slot: number): string => {
  if (!Number.isInteger(slot) || slot < 0 || slot >= SCHEDULE_SLOTS) return DASH;
  const monthIndex = Math.floor(slot / 3);
  const year = monthIndex < 3 ? 2026 : 2027;
  const month = ((9 + monthIndex) % 12) + 1;
  return `${year}年${month}月${JUN[slot % 3] ?? ''}旬`;
};

export const PERMISSION_LABEL: Readonly<Record<Permission, string>> = {
  'tasks:write': '業務マスタの編集',
  'schedule:write': '推進スケジュールの編集',
  'cases:write': '案件の管理',
  'staff:write': '社員の管理',
  'allocations:write': '配置の修正',
  'accounts:write': 'アカウント管理',
};
